export default {
  NO: 0,
  LOW: 1,
  HIGH: 4
};
